export const ERROR_CODES = {
    103:'El token no es válido',
    301:'Error con el servidor o base de datos',
    401:'No se encontró el usuario',
    402:'El correo electrónico ya está en uso',
    106:'Correo y/o contraseña incorrectos'
}